// ConditionsModal.js
import React from 'react';
import './ConditionsModal.css';

const ConditionsModal = ({ onAccept }) => {
    return (
        <div className="modal-overlay">
            <div className="modal-content1" style={{width:'98%'}}>
                <p>שלום רב,</p>
                <p>ברוך הבא ללוח יד 2 של ציוד הדת הצה"לי</p>
                <p>פלטפורמה זו פותחה במטרה <span className='bold'> להנגיש ולייעל </span>את תהליך שיתוף והעברת ציוד דת בין יחידות הצבא.</p> 
                <p className='bold'>תנאי השימוש :</p>
                <p> <span className='bold'>סיווג הפריטים: </span>ניתן לשתף פריטים בעלי סיווג בלמ"ס (בלתי מסווג) בלבד.</p>
                <p> <span className='bold'>אישור פריטים:</span>פריטי דת צה"ליים יאושרו להעלאה לאתר.</p>
                <p>עבור פריטי דת שאינם צה"ליים, יש לבצע תהליך אישור תרומה דרך העמוד הראשי בבוט מדור ציוד דת ולוגיסטיקה.</p>
                <p> <span className='bold'>תהליך פרסום מודעה:</span>כל הוספת מודעה מחייבת אישור מדור ציוד דת ולוגיסטיקה לפני פרסומה.
                    המודעה תיבחן ותאושר עד 24 שעות מרגע שהועלתה לאתר.</p>
                <p> <span className='bold'>העברת פריטים ברישום הצה"לי:</span>עבור פריטים המחויבים ברישום הצה"לי, יש לבצע את העברתם בציר הלוגיסטי של היחידה ובהתאם להוראות מקל"ר בנושא.                </p>
                <p> <span className='bold'>ביטחון מידע:</span>מטעמי ביטחון מידע, יש להימנע מפירוט המיקום המדויק של היחידה בה נמצא הפריט.
                    יש לציין רק אזור גאוגרפי בלבד (צפון/מרכז/דרום/ירושלים/יהודה ושומרון).
                </p>
                <p> <span className='bold' style={{marginBottom:'10px'}} >אחריות על איכות המוצר:</span>מדור ציוד דת ולוגיסטיקה אינו נושא באחריות לאיכות המוצרים המועלים באתר.</p>

                <p className='bold11'>כאן בשבילך ולמענך,
                </p>
                <p className='bold1'>מדור ציוד דת ולוגיסטיקה</p>
                <button style={{ background: '#4CAF50', color: 'white', padding: '10px 10px', border: 'none', borderRadius: '5px', cursor: 'pointer', marginTop: '20px', width: '100%' }} className="accept-button1" onClick={onAccept}>אני מאשר/ת</button>
            </div>
        </div >
    );
};

export default ConditionsModal;
